export default "__VITE_ASSET__Dwlyi0BS__"